import React, { memo, useEffect, useRef } from 'react';
import { IBaseSection, IContent } from '@zmedia/bm-soccer-ui/interface';
import { Element, Title } from '@zmedia/bm-soccer-ui/components';
import { useIntersectionLoader } from '@zmedia/bm-soccer-ui/hooks';
import LoadMore from './LoadMore';
import Loading from '../Loading';

interface IProps extends IBaseSection<IContent> {
    className?: string;
    currentPage?: number;
    fetchFn: (...params: any) => Promise<any>;
    ComponentList?: any;
    ComponentEmpty?: React.FunctionComponent<any>;
    ComponentListProps: any;
    showButtonLoadMore?: boolean;
    title?: string;
}

export function InfiniteList(props: IProps) {
    const {
        className = '',
        fetchFn,
        items = [],
        ComponentEmpty,
        ComponentList,
        ComponentListProps,
        currentPage = 1,
        showButtonLoadMore = true,
        title = '',
    } = props;
    const firstRender = useRef(true);
    const [loaderRef, list, listAction] = useIntersectionLoader(
        fetchFn,
        {
            items: items,
            currentPage,
            isFetching: false,
        },
        {
            rootMargin: '300px',
        },
        currentPage
    );

    useEffect(() => {
        if (!firstRender.current) {
            listAction.refresh({
                items: items,
                currentPage,
                isFetching: false,
            });
        }
        firstRender.current = false;
    }, [fetchFn]);

    if (!list.isFetching && !list.items.length && ComponentEmpty) {
        return <ComponentEmpty />;
    }

    return (
        <>
            {title && <Title renderAs='h2'>{title}</Title>}
            <Element className={className}>
                <ComponentList {...ComponentListProps} items={list.items} />
                <LoadMore
                    startPage={currentPage}
                    currentPage={list.currentPage}
                    showButtonLoadMore={showButtonLoadMore}
                    hasMore={list.hasMore}
                    isFetching={list.isFetching}
                    loaderRef={loaderRef}
                />
                {!(list.currentPage === currentPage) && list.isFetching && (
                    <Loading />
                )}
            </Element>
        </>
    );
}

export default memo(InfiniteList);
